<template>
  <div class="show-param">
    <div v-for="(item, i) in paramList" :key="item + i" class="param-line">
      <el-input v-model="item.key" class="input-width" disabled></el-input>
      <el-input v-model="item.value" class="input-width" disabled></el-input>
      <div :class="['btn-box', i === 0 ? 'add' : 'delete']">
        <i v-if="i === 0" class="el-icon-plus"></i>
        <i v-else class="el-icon-delete"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowParam',
  props: {
    list: {
      type: Array,
      default: () => {
        return [{ key: '', value: '' }]
      }
    }
  },
  data() {
    return {
      paramList: this.list
    }
  }
}
</script>

<style scoped lang="scss">
.show-param {
  .param-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--base-size-8);
    &:last-child {
      margin-bottom: 0;
    }
    .input-width {
      width: calc((100% - var(--base-size-32)) / 2 - var(--base-size-4));
    }
    .btn-box {
      width: var(--base-size-32);
      height: var(--base-size-32);
      line-height: var(--base-size-32);
      text-align: center;
      border-radius: var(--base-border-radius);
      font-size: var(--base-font-size-extra-large);
      color: var(--base-color-text-placeholder);
      background: var(--base-background-color-lighter);
      cursor: not-allowed;
      
      i {
        font-weight: bolder;
      }
    }
  }
}
</style>
